import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';

export const fetchTread = createAsyncThunk(
  'tread/get',
  async (data, thunkAPI) => {
    try {
      const { ownerId, treadId } = data;
      const response = await api.getTread(ownerId, treadId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: tread/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);


export const saveTreadDraft = createAsyncThunk(
  'tread/save/draft',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, treadId, treadData } = data;

      const response = await api.saveDraftTread(itemOwnerId, treadId, treadData);

      if(response.status === 'ok') {
        return treadData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: tread/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveTreadPublished = createAsyncThunk(
  'tread/save/published',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, treadId, treadData } = data;

      const response = await api.savePublishedTread(itemOwnerId, treadId, treadData);

      if(response.status === 'ok') {
        return treadData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: tread/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const publishTread = createAsyncThunk(
  'tread/publish',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, treadId, treadData } = data;

      const response = await api.publishTread(itemOwnerId, treadId, treadData);

      if(response.status === 'ok') {
        return treadData;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: tread/publish', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

export const createTread = createAsyncThunk(
  'tread/create',
  async (data, thunkAPI) => {
    try {
      const { itemOwnerId, treadData } = data;
      const response = await api.createTread(itemOwnerId, treadData);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      console.error('ERROR: tread/create', e.message);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  draft: {},
  published: {},
  master: {},
  equalStatus: false,
  canEdit: false,
  fetchStatus: 'idle',
  fetchError: null,
  createStatus: 'idle',
  createError: null,
  saveStatus: 'idle',
  saveError: null
};

export const treadSlice = createSlice({
  name: 'tread',
  initialState,
  reducers: {
    clearSaveStatus: (state, action) => {
      state.saveStatus = 'idle';
    },
    clearCreateStatus: (state, action) => {
      state.createStatus = 'idle';
    },
    resetStatus: (state, action) => {
      return initialState;
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchTread.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;

      state.draft = action.payload.draft || {itemLines: []};
      state.published = action.payload.published?.code ? action.payload.published : {};
      state.master = action.payload.master || {};
      state.equalStatus = action.payload.equalStatus;
      state.canEdit = action.payload.canEdit;
    },
    [fetchTread.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchTread.rejected]: (state, action) => {
      state.fetchStatus = 'failed';
      state.fetchError = action.payload.messages.join(', ');
    },

    [saveTreadDraft.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.draft = action.payload;
      state.equalStatus = false;
    },
    [saveTreadDraft.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveTreadDraft.rejected]: (state, action) => {
      state.saveStatus = 'failed';

      if(typeof action.payload === 'string') {
        state.saveError = {
          message: action.payload
        };
      } else {
        state.saveError = {
          message: action.payload.messages.join(', '),
          fields: action.payload.result.errors
        };
      }
    },

    [saveTreadPublished.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.published = action.payload;
      state.equalStatus = false;
    },
    [saveTreadPublished.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveTreadPublished.rejected]: (state, action) => {
      state.saveStatus = 'failed';

      if(typeof action.payload === 'string') {
        state.saveError = {
          message: action.payload
        };
      } else {
        state.saveError = {
          message: action.payload.messages.join(', '),
          fields: action.payload.result.errors
        };
      }
    },

    [publishTread.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      state.published = action.payload;
      state.draft = action.payload;
      state.equalStatus = true;
    },
    [publishTread.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [publishTread.rejected]: (state, action) => {
      state.saveStatus = 'failed';
      console.log('action', action);

      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.saveError = {
        message: message
      };
    },

    [createTread.fulfilled]: (state, action) => {
      state.createStatus = 'succeeded';
      state.createError = null;
      state.draft.code = action.payload;
      state.equalStatus = false;
    },
    [createTread.pending]: (state, action) => {
      state.createStatus = 'loading';
      state.createError = null;
    },
    [createTread.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }

      state.createStatus = 'failed';
      state.createError = {
        message: message,
        fields: action.payload.result?.errors
      };
    },
    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    }
  }
});

export const { clearSaveStatus, clearCreateStatus, resetStatus } = treadSlice.actions;

export const selectTread = state => state.tread;

export const selectFetchStatus = state => ({
  fetchStatus: state.tread.fetchStatus,
  fetchError: state.tread.fetchError,
  draft: state.tread.draft,
  published: state.tread.published
});

export const selectCreateStatus = state => ({
  status: state.tread.createStatus,
  error: state.tread.createError,
  tread: state.tread.draft
});

export const selectMaster = state => state.tread.master;
export const selectEqualStatus = state => state.tread.equalStatus;
export const selectAccess = state => state.tread.canEdit;

export const selectSaveStatus = state => ({
  saveStatus: state.tread.saveStatus,
  saveError: state.tread.saveError,
});


export default treadSlice.reducer;
